export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14769.815165f3.jpg";